(() => {
  'use strict';
  const money = (cents) => new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(cents / 100);
  const update = (detail) => {
    document.querySelectorAll('[data-vpb-selector]').forEach((root) => {
      const checked = root.querySelector('input:checked');
      const bottles = Number(detail?.bottles ?? checked?.dataset.bottles);
      const price = Math.round(Number(detail?.price ?? checked?.dataset.price) * 100);
      const single = Number(root.dataset.vpbSinglePrice);
      if (!Number.isFinite(price) || !Number.isFinite(bottles) || bottles < 1) return;
      const saving = Math.max(0, single * bottles - price);
      document.querySelectorAll('[data-vpb-main-compare]').forEach((node) => {
        node.textContent = money(Math.floor(price * 1.2 / 100) * 100);
      });
      root.querySelector('[data-vpb-count]').textContent = `${bottles} flacon${bottles > 1 ? 's' : ''}`;
      root.querySelector('[data-vpb-unit]').textContent = `${money(Math.round(price / bottles))}/flacon`;
      root.querySelector('[data-vpb-saving]').textContent = saving > 0 ? `${money(saving)} économisés` : '';
    });
  };
  document.addEventListener('veranelle:offer-change', (event) => update(event.detail));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(), { once: true });
  else update();
})();
